$(document).on('click','.cookies_main .btn',function(){
    $('.cookies_main').addClass('bottom-out');
});
